import Modal from './Modal';

/**
 * Confirmation before item setup upload: file name + company/division.
 */
export default function UploadDraftConfirmModal({
  open,
  fileName,
  companyDivisionLabel,
  onConfirm,
  onCancel,
  confirmLoading = false,
}) {
  return (
    <Modal
      open={open}
      title="Confirm item setup"
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmLabel="Confirm"
      cancelLabel="Cancel"
      confirmLoading={confirmLoading}
    >
      <p className="modal-message">
        Please confirm that the items outlined in <strong>{fileName}</strong> are approved to be
        setup and placed in draft status for <strong>{companyDivisionLabel}</strong>.
      </p>
    </Modal>
  );
}
